import Aegis from 'aegis-web-sdk';
import axios from 'axios';

export const DebugAPIBase = 'http://localhost:8080/apis/v1';
// export const APIBase = 'https://tpss.cloud.tencent.com/apis/v1';
// export const APIBase = `https://${window.location.host}/apis/v1`;

function getAPIBase() {
  if (window.location.host === 'localhost:3000') {
    // return 'https://tpss-dev.cloud.tencent.com/apis/v1';
    return DebugAPIBase;
  } else {
    return `${window.location.protocol}//${window.location.host}/apis/v1`;
  }
}

// 创建带有基础配置的实例
export const apiClient = axios.create({
  baseURL: getAPIBase(),
  timeout: 10000, // 10秒超时
  withCredentials: true, // 允许跨域请求自动携带 Cookie（uin/skey）
  headers: {
    'Content-Type': 'application/json'
  }
});

// 跳转到腾讯云统一登录页，登录成功后按 s_url 回跳原页面
function redirectToLogin() {
  const sUrl = encodeURIComponent(window.location.href);
  window.location.replace(`https://cloud.tencent.com/login?s_url=${sUrl}`);
}

// // 添加请求拦截器
// apiClient.interceptors.request.use(（config） => {
//   const token = localStorage.getItem('authToken');
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// 添加响应拦截器
apiClient.interceptors.response.use(
  (response) => response.data, // 直接返回数据部分
  (error) => {
    if (error.response) {
      // 401 未登录 / 登录态过期 → 跳腾讯云统一登录页
      if (error.response.status === 401) {
        redirectToLogin();
        // 阻断后续 .catch 分支，避免业务层再弹错误提示
        return new Promise(() => {});
      }
      // 服务器返回了错误状态码 (4xx, 5xx)
      console.error('API Error:', error.response.status, error.response.data?.Data);
      return Promise.reject({
        status: error.response.status,
        message: error.response.data?.message || '请求失败'
      });
    } else if (error.request) {
      // 请求已发出但没有收到响应
      console.error('Network Error:', error.request);
      return Promise.reject({ message: '网络错误，请检查连接' });
    } else {
      // 其他错误
      console.error('Request Setup Error:', error.message);
      return Promise.reject({ message: '请求配置错误' });
    }
  }
);

export const aegis = new Aegis({
  id: 'EPegJUrz6JQVnPb2Qw', // 上报 id
  uin: 'xxx', // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 应用页面跳转的时候开启 pv 计算
  hostUrl: `https://${window.location.host}`
});
